// core
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

// constants
import { STEP_ONE, STEP_TWO } from '../constants/member-validation-flow-v001';

// services
import { CustomerService } from '@campfire-nx/api';
import { PartnerBrandService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class MemberValidationFlowService {
  steps = [STEP_ONE, STEP_TWO];
  currentStep = 0;
  user!: any;

  constructor(
    private router: Router,
    private partnerBrandService: PartnerBrandService,
    private customerService: CustomerService
  ) { }

  next(payload: any) {
    return new Promise((resolve, reject) => {
      const currentStep = this.steps[this.currentStep];

      if (payload.avios_member_number) {
        this.customerService
          .update({
            partner_slug: this.partnerBrandService.getAttribute('slug', 'partner'),
            avios_member_number: payload.avios_member_number
          })
          .then((response: any) => {
            resolve(this.getSecondStep(this.user))
          })
          .catch((error: HttpErrorResponse) => {
            currentStep.errors = {
              'avios_member_number': 'Unfortunately we haven\'t been able to match your details with this membership number. Please try again.'
            };
            resolve(currentStep);
          });
      } else {
        reject(null);
      }
    });
  }

  jump() {
    this.router.navigate(['/dashboard']);
    return new Promise((resolve) => {
      resolve(true);
    });
  }

  getFirstStep(user: any) {
    this.user = user;
    this.currentStep = 0;
    const step = this.steps[this.currentStep];
    step.data.last_name = user.last_name;
    step.human.last_name = user.last_name;

    return step;
  }

  getSecondStep(user: any) {
    const companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');
    const partnerSlug = this.partnerBrandService.getAttribute('slug', 'partner');
    let termsUrl = companyInfo.TERMS_URL || '/terms';
    if (partnerSlug === 'avios') {
      termsUrl = 'https://wanda.world/avios-award-terms-conditions';
    }
    let termsLink = `<a href="${termsUrl}" target="_blank">Terms & Conditions</a>`;
    
    this.user = user;
    this.currentStep = 1;
    const step = this.steps[this.currentStep];
    step.data.last_name = user.last_name;
    step.human.last_name = user.last_name;
    step.sections[0].info.content = step.sections[0].info.content.replace('{{ termsLink }}', termsLink);

    return step;
  }
}
